import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      // Control visibility
      transform: 'translateY(-1000%)',
      '&:focus': {
        transform: 'translateY(0%)',
      },

      // Position the element absolutely
      position: 'absolute',
      top: theme.spacing(1),
      left: theme.spacing(1),
      zIndex: 99999,

      // Dimensions
      display: 'inline-block',
      height: theme.spacing(5),
      lineHeight: `${theme.spacing(3)}px`,
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),

      // Colors
      color: theme.palette.common.white,
      backgroundColor: theme.palette.shelfBlue[500],

      // Text
      fontWeight: 500,
      fontFamily: 'Roboto, Arial, Helvetica, sans-serif',

      // Outline
      outline: 'none',
      // an outline is typically used to show focus,
      // but the element is only visible at all when focused
    },
  };
});

const SkipToContentLink = ({ text = 'Skip to Main Content', ...props }) => {
  const classes = useStyles();

  return (
    <a href="#mainContent" className={classes.root} {...props}>
      {text}
    </a>
  );
};

SkipToContentLink.propTypes = {
  /**
   * The text to display for the link.
   */
  text: PropTypes.string,
};

export default SkipToContentLink;
